export { TikTokIcon } from "./tiktok";
